<template>
  <a :href="href" class="brand" target="_blank" noborder>
    <img :src="image" class="brand__image" />
    <div class="brand__overlay">
      <div class="brand__overlay__logo">
        <slot name="overlay-logo"></slot>
      </div>
      <div class="brand__overlay__text">
        <h3 class="brand__overlay__title h1">{{ title }}</h3>
        <p class="brand__overlay__description">
          {{ description }}
        </p>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'brand',
  props: {
    image: String,
    title: String,
    description: String,
    href: {
      type: String,
      default: () => '',
    },
  },
};
</script>

<style lang="scss" scoped>
.brand {
  @extend .panel !optional;
  padding: 0;

  width: 100%;
  min-height: 260px;
  aspect-ratio: 590/230;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  margin-bottom: $grid-gutter-width / 2;

  @include media-breakpoint-up(md) {
    margin-bottom: 0;
  }

  &__image {
    min-height: 100%;
    object-fit: cover;
  }

  &__overlay {
    @extend .panel !optional;

    background: linear-gradient(
      180deg,
      rgba(57, 65, 78, 0) 0%,
      rgba(57, 65, 78, 0) 40%,
      #39414e 100%
    );
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    z-index: 1;

    &__logo {
      background: $white;
      padding: 12px 40px;
      border-radius: $border-radius-lg;
      display: inline-block;
      align-self: flex-end;
      position: relative;

      svg {
        height: 37px;
        width: auto;
      }
      img {
        width: auto;
        max-height: 37px;
      }
    }
    &__text {
      position: relative;
      z-index: 10;
      * {
        color: $white;
        margin-bottom: 0;
      }
    }
    &__title {
      @include media-breakpoint-up(md) {
        font-size: 25px;
      }

      @include media-breakpoint-up(lg) {
        margin-bottom: $grid-gutter-width / 4;
        font-size: 32px;
      }
    }
    &__description {
      @include media-breakpoint-up(lg) {
        margin-bottom: $grid-gutter-width / 4;
        font-size: 16px;
      }
    }
  }
}
</style>
